import React from 'react';

/** "今日 14:22" / "昨日 18:40" / "9/20 11:05" from an ISO timestamp. Real data only — never a placeholder. */
export function fmtWhen(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const now = new Date();
  const dayKey = (x) => `${x.getFullYear()}-${x.getMonth()}-${x.getDate()}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const hm = `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`;
  if (dayKey(d) === dayKey(now)) return `今日 ${hm}`;
  if (dayKey(d) === dayKey(yesterday)) return `昨日 ${hm}`;
  return `${d.getMonth() + 1}/${d.getDate()} ${hm}`;
}

/**
 * 誰から / 時間 / ステータス — used by both 確認中 and 行動記録管理.
 * `status` decides which timestamp is shown: 確認中 → submittedAt, 確定 → reviewedAt.
 */
export default function ApprovalTable({ rows, status, flashId, onOpen }) {
  if (!rows.length) {
    return (
      <div className="apv-empty">
        {status === '確認中' ? '確認中はありません' : '確定した記録はまだありません'}
      </div>
    );
  }
  return (
    <table className="apv-list">
      <thead>
        <tr>
          <th>誰から</th>
          <th>時間</th>
          <th>ステータス</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr
            key={r.id}
            className={`apv-row${r.id === flashId ? ' is-flash' : ''}`}
            onClick={() => onOpen(r)}
          >
            <td>
              <div className="apv-who">
                {r.stylist}
                <span className={`apv-kind${r.type === 'goals' ? ' apv-kind--goals' : ''}`}>
                  {r.type === 'goals' ? '目標' : '行動'}
                </span>
              </div>
              <div className="apv-store">{r.store}</div>
            </td>
            <td className="apv-time">{fmtWhen(status === '確定' ? r.reviewedAt : r.submittedAt)}</td>
            <td>
              <span className={`apv-badge ${status === '確定' ? 'apv-badge--ok' : 'apv-badge--wait'}`}>
                {status}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
